var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"h1 text-muted"},[_c('i',{staticClass:"fa fa-x fa-coffee",attrs:{"aria-hidden":"true"}}),_vm._v("\n    Just relax...\n  ")]),_vm._v(" "),_c('h4',{staticClass:"text-muted"},[_vm._v("We are building something awesome here.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"text-fuchsia"},[_vm._v("Meanwhile, please checkout other sections, like, Partner, Party, Activation Codes, etc.")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/common/UnderConstruction.vue